module.exports = __webpack_public_path__ + "media/images/pic/teachers/magdalena-kisly-e601b9043f8d29f54bb1259581a0129a.webp";